import { v4 as uuidv4 } from 'uuid';

/**
 * Fired whenever the active session id changes. The avatar page stays mounted across
 * conversation switches, so anything deriving state from the session id has to be told
 * when it moves rather than reading it once at mount.
 */
export const SESSION_ID_CHANGED_EVENT = 'avatar:session-id-changed';

const notifySessionIdChanged = () => {
    try {
        window.dispatchEvent(new CustomEvent(SESSION_ID_CHANGED_EVENT));
    } catch {
        // No-op: a missing CustomEvent constructor must not break session switching.
    }
}

export const getUserSettings = () => {
    return JSON.parse(window.localStorage.getItem("user-settings") || '{}');
}

export const initNewSessionId = () => {
    const userSettings = getUserSettings();
    userSettings.sessionId = uuidv4();
    window.localStorage.setItem('user-settings', JSON.stringify(userSettings));
    notifySessionIdChanged();
}

export const getSessionId = () => {
    const userSettings = getUserSettings();
    return userSettings.sessionId;
}

export const setSessionId = (sessionId: string) => {
    const userSettings = getUserSettings();
    if (userSettings.sessionId === sessionId) {
        return;
    }
    userSettings.sessionId = sessionId;
    window.localStorage.setItem('user-settings', JSON.stringify(userSettings));
    notifySessionIdChanged();
}